import styled from "styled-components/macro";
import { COLORS } from "../../../../../layout/theme";

export const Inner = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 20px;
	width: 100%;
	height: 500px;
	overflow: auto;
	padding: 1rem;

	scrollbar-width: auto;
	scrollbar-color: ${COLORS.SkeletonGrey} ${COLORS.White};

	::-webkit-scrollbar {
		width: 7px;
	}

	::-webkit-scrollbar-track {
		background: ${COLORS.White};
	}

	::-webkit-scrollbar-thumb {
		background-color: ${COLORS.SkeletonGrey};
		border-radius: 10px;
		border: 2px solid ${COLORS.White};
	}
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;
